import React from 'react';
import queryString from 'query-string';
import SocialCard from './SocialCard';

function App() {
  const location = typeof window !== undefined ? window.location : {};
  const data = queryString.parse(location.search);

  return (
    <div className="App">
      <SocialCard 
        {...data} 
        illustrationUrl={data.illustrationUrl && decodeURIComponent(data.illustrationUrl)}
        title={data.title && decodeURIComponent(data.title)} 
        subtitle={data.subtitle && decodeURIComponent(data.subtitle)} 
      />
    </div>
  );
}
export default App;